class HCarousel extends HTMLElement {
  constructor() {
    super()
    Haciendola.customizer.subscribe(this)
    this.slides = []
    this.dots = []
    this.timeout
    this._events = {
      select: () => {
        const [index] = this.embla.slidesInView(true)
        this.updateControls(index)
        this.initAutoplay()
      },
      pointerUp: () => this.initAutoplay(),
      pointerDown: () => this.stopAutoplay(),
    }
    this.config = {
      slidesPerView: this.dataset.slidesPerView || 1,
      gap: this.dataset.gap || 0,
      slideDuration: 3,
      slidesToScroll: this.dataset.slidesToScroll || 1,
      loop: true,
      controls: {
        dots: true,
        arrows: true,
      },
    }
    if (this.dataset.autoinit === 'true') this.configure(this.config)
  }

  init(config) {
    // Cada uno requiere al otro, el orden es importante
    this.updateView()
    this.wrap()

    this.initEmbla(config)

    this.makeControls()
    this.updateControls()
    this.listeners()
    this.initAutoplay()
  }
  // Wrap: Parsea el dom a la estructura correcta
  wrap() {
    this.viewport = document.createElement('div')
    this.container = document.createElement('div')

    this.viewport.classList.add('haciendola-carousel__viewport')
    this.container.classList.add(
      'haciendola-carousel__container',
      'embla__container'
    )

    const childrens = [...this.children]
    this.slides = childrens.map((el, index) => {
      // Manejar el block en el customizer
      el.customizerEvent('select', () => {
        this.stopAutoplay()
        this.embla.scrollTo(index)
      })

      const slide = document.createElement('div')
      slide.classList.add('haciendola-carousel__slide', 'embla__slide')
      slide.appendChild(el)
      this.container.appendChild(slide)
      return slide
    })

    this.viewport.appendChild(this.container)
    this.appendChild(this.viewport)
    this.classList.add('initialized')
  }

  // InitEmbla: Inicializa la librería embla
  initEmbla(config) {
    this.embla = EmblaCarousel(this.viewport, {
      speed: 5,
      containScroll: 'trimSnaps',
      align: 'start',
      skipSnaps: true,
      ...config,
    })
  }

  // MakeControls: Genera los controles
  makeControls() {
    this.makeArrows()
    this.makeDots()
  }

  makeArrows() {
    if (this.arrowsContainer) this.arrowsContainer.remove()

    this.arrowsContainer = document.createElement('div')
    if (!this._internalConfig.controls.arrows) return
    if (!this.embla.canScrollNext() && !this.embla.canScrollPrev()) return

    this.prevBtn = document.createElement('button')
    this.nextBtn = document.createElement('button')

    this.arrowsContainer.classList.add('haciendola-carousel__arrows')

    this.prevBtn.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.35408 9.35402C5.40065 9.30758 5.43759 9.2524 5.46279 9.19165C5.488 9.13091 5.50098 9.06579 5.50098 9.00002C5.50098 8.93425 5.488 8.86913 5.46279 8.80839C5.43759 8.74764 5.40065 8.69247 5.35408 8.64602L1.70708 5.00002L5.35408 1.35402C5.44797 1.26013 5.50071 1.1328 5.50071 1.00002C5.50071 0.867245 5.44797 0.739908 5.35408 0.646021C5.2602 0.552135 5.13286 0.49939 5.00008 0.49939C4.86731 0.49939 4.73997 0.552135 4.64608 0.646021L0.646083 4.64602C0.599519 4.69247 0.562576 4.74764 0.53737 4.80839C0.512164 4.86913 0.499189 4.93425 0.499189 5.00002C0.499189 5.06579 0.512164 5.13091 0.53737 5.19165C0.562576 5.2524 0.599519 5.30758 0.646083 5.35402L4.64608 9.35402C4.69253 9.40058 4.7477 9.43753 4.80845 9.46273C4.86919 9.48794 4.93432 9.50091 5.00008 9.50091C5.06585 9.50091 5.13097 9.48794 5.19172 9.46273C5.25246 9.43753 5.30764 9.40058 5.35408 9.35402V9.35402Z" fill="currentColor"/></svg>
    `
    this.nextBtn.innerHTML = `<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.645917 0.645979C0.599354 0.692425 0.562411 0.747601 0.537205 0.808346C0.511998 0.869091 0.499024 0.934212 0.499024 0.999979C0.499024 1.06575 0.511998 1.13087 0.537205 1.19161C0.562411 1.25236 0.599354 1.30753 0.645917 1.35398L4.29292 4.99998L0.645917 8.64598C0.552031 8.73987 0.499286 8.8672 0.499286 8.99998C0.499286 9.13275 0.552031 9.26009 0.645917 9.35398C0.739804 9.44787 0.867141 9.50061 0.999917 9.50061C1.13269 9.50061 1.26003 9.44787 1.35392 9.35398L5.35392 5.35398C5.40048 5.30753 5.43742 5.25236 5.46263 5.19161C5.48784 5.13087 5.50081 5.06575 5.50081 4.99998C5.50081 4.93421 5.48784 4.86909 5.46263 4.80834C5.43742 4.7476 5.40048 4.69242 5.35392 4.64598L1.35392 0.645979C1.30747 0.599416 1.2523 0.562473 1.19155 0.537267C1.13081 0.51206 1.06568 0.499085 0.999917 0.499085C0.93415 0.499085 0.869029 0.51206 0.808284 0.537267C0.747539 0.562473 0.692363 0.599416 0.645917 0.645979V0.645979Z" fill="currentColor"/></svg>
    `

    this.prevBtn.addEventListener('click', () => this.embla.scrollPrev())
    this.nextBtn.addEventListener('click', () => this.embla.scrollNext())

    this.arrowsContainer.append(this.prevBtn, this.nextBtn)
    this.appendChild(this.arrowsContainer)
  }

  makeDots() {
    if (this.dotsContainer) this.dotsContainer.remove()

    this.dotsContainer = document.createElement('div')
    if (!this._internalConfig.controls.dots) return

    this.dotsContainer.classList.add('haciendola-carousel__dots')
    let settings = this._internalConfig.dotsSettings || {}
    if (settings.renderMode === 'flow') {
      this.dotsContainer.style.position = 'static'
    }

    const generateDotBtns = () => {
      const template = `<div class="haciendola-carousel__dot"></div>`
      this.dotsContainer.innerHTML = this.embla
        .scrollSnapList()
        .reduce(acc => acc + template, '')
      return [].slice.call(
        this.dotsContainer.querySelectorAll('.haciendola-carousel__dot')
      )
    }

    this.dots = generateDotBtns()

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.embla.scrollTo(index))
    })

    this.appendChild(this.dotsContainer)
  }

  updateControls(index = 0) {
    if (!this._internalConfig.controls.arrows) {
      this.arrowsContainer.style.display = 'none'
    } else {
      this.arrowsContainer.style.display = 'flex'
      const active = this.slides[index].firstChild
      if (active) {
        const color = active.dataset.arrowsColor
        if (color) {
          this.arrowsContainer.style.setProperty('--arrows-color', color)
        }
      }
    }
    if (!this._internalConfig.controls.dots) {
      this.dotsContainer.style.display = 'none'
    } else {
      this.dotsContainer.style.display = 'flex'
      this.dots.forEach((dot, i) =>
        dot.classList.toggle('active', i === this.embla.selectedScrollSnap())
      )
    }
  }

  // UpdateView: Actualiza la visualización de los slides
  updateView() {
    this.style.setProperty(
      '--slide-width',
      `${100 / this._internalConfig.slidesPerView}%`
    )
    this.style.setProperty('--gap', `${this._internalConfig.gap}px`)
  }

  // Listeners: Crea los eventListeners
  listeners() {
    this.embla.on('init', () => {
      this.embla.on('select', this._events.select)
      this.embla.on('pointerUp', this._events.pointerUp)
      this.embla.on('pointerDown', this._events.pointerDown)
    })
    let debounce
    this.embla.on('reInit', () => {
      if (debounce) clearTimeout(debounce)
      debounce = setTimeout(() => {
        this.clear()
        this.embla.on('select', this._events.select)
        this.embla.on('pointerUp', this._events.pointerUp)
        this.embla.on('pointerDown', this._events.pointerDown)
        this.makeControls()
        this.updateControls()
      }, 200)
    })

    window.addEventListener('resize', () => {
      this._setInternalConfig()
      this.updateView()
    })

    this.customizerEvent('unload', ({ subscriber }) => {
      subscriber.embla.destroy()
      subscriber.clear()
    })
  }
  clear() {
    this.embla.off('select', this._events.select)
    this.embla.off('pointerUp', this._events.pointerUp)
    this.embla.off('pointerDown', this._events.pointerDown)
  }

  // Autoplay: Navegación automática
  initAutoplay() {
    if (this.timeout) clearTimeout(this.timeout)
    if (!this._internalConfig.autoplay) return
    this.timeout = setTimeout(() => {
      this.embla.scrollNext()
    }, this._internalConfig.slideDuration * 1000)
  }
  stopAutoplay() {
    if (this.timeout) {
      this._internalConfig.autoplay = false
      clearTimeout(this.timeout)
    }
  }

  // Configure: configuración/actualización de los ajustes responsive
  _setInternalConfig() {
    const width = innerWidth
    const config = { ...this.config }
    for (let bp in this.config.breakpoints) {
      if (width >= bp) {
        for (let k in this.config.breakpoints[bp]) {
          config[k] = this.config.breakpoints[bp][k]
        }
      }
    }
    this._internalConfig = config
  }

  configure(config) {
    for (let k in config) {
      this.config[k] = config[k]
    }

    const breakpoints = {}
    if (config.breakpoints) {
      for (let bp in config.breakpoints) {
        breakpoints[`(min-width: ${bp}px)`] = config.breakpoints[bp]
      }
    }

    this._setInternalConfig()

    this.init({ ...this.getEmblaConf(), breakpoints })
  }

  getEmblaConf() {
    return {
      slidesToScroll: this._internalConfig.slidesToScroll,
      loop: this._internalConfig.loop,
    }
  }
}
window.customElements.define('haciendola-carousel', HCarousel)
